export const TRANSITION_TO_SPLIT_SCREEN_WIDTH = 720
